module.exports = __webpack_public_path__ + "img/default_store_banner.147a090a.png";